import { effects } from 'redux-saga'
import { push as pushPath } from 'react-router-redux'

import { receiveCredentials } from '../../modules/authentication'
import { begin, end } from '../../modules/loading'

export default function* loginSaga(getUser, action) {
  try {
    yield effects.put.resolve(begin('authentication'))
    const { hmac, user } = yield effects.call(getUser, action.payload.token)

    yield [
      effects.put.resolve(receiveCredentials(user, hmac)),
      effects.put.resolve(pushPath(action.payload.returnTo || '/')),
    ]
  } finally {
    yield effects.put.resolve(end('authentication'))
  }
}



// WEBPACK FOOTER //
// ./deps/internal-components/src/redux/sagas/authentication/login.js